<!-- Main container -->
<div class="terms-container">
    <!-- First Terms Popup -->
    <div class="terms-popup animate-card" *ngIf="currentStep === 1">
      <div class="card-header">
        <h2>ΚΕΙΜΕΝΟ ΣΥΝΑΙΝΕΣΗΣ</h2>
      </div>
      <div class="card-body" #firstTermsScroll (scroll)="onTermsScroll($event, 1)">
        <div class="terms-content" [innerHTML]="firstTermsContent">
          <!-- Content will be inserted dynamically -->
        </div>
      </div>
      <div class="card-footer">
        <div class="checkbox-section">
          <label class="custom-checkbox">
            <input 
              type="checkbox" 
              [disabled]="!firstTermsScrolled" 
              [(ngModel)]="firstTermsAccepted"
            >
            <span class="checkmark-box"></span>
            <span class="checkbox-text">Συναινώ με τους όρους</span>
          </label>
        </div>
        <div class="button-section">
          <button 
            class="connectivity-button" 
            [disabled]="!firstTermsAccepted" 
            (click)="nextStep()"
          >
           {{'SUBMIT' | translate}}
          </button>
        </div>
      </div>
    </div>
  
    <!-- Second Terms Popup -->
    <div class="terms-popup animate-card" *ngIf="currentStep === 2">
      <div class="card-header">
        <h2>Πολιτική Προστασίας Προσωπικών Δεδομένων</h2>
      </div>
      <div class="card-body" #secondTermsScroll (scroll)="onTermsScroll($event, 2)">
        <div class="terms-content" [innerHTML]="secondTermsContent">
          <!-- Content will be inserted dynamically -->
        </div>
      </div>
      <div class="card-footer">
        <div class="checkbox-section">
          <label class="custom-checkbox">
            <input 
              type="checkbox" 
              [disabled]="!secondTermsScrolled" 
              [(ngModel)]="secondTermsAccepted"
            >
            <span class="checkmark-box"></span>
            <span class="checkbox-text">Συναινώ με τους όρους</span>
          </label>
        </div>
        <div class="button-section">
          <button 
            class="connectivity-button" 
            [disabled]="!secondTermsAccepted" 
            (click)="nextStep()"
          >
          {{'SUBMIT' | translate}}
          </button>
        </div>
      </div>
    </div>
  
    <!-- Checkboxes Popup -->
    <div class="terms-popup animate-card" *ngIf="currentStep === 3">
      <div class="card-header">
        <h2>ΔΗΛΩΣΕΙΣ – ΕΠΙΒΕΒΑΙΩΣΕΙΣ</h2>
      </div>
      <div class="card-body">
        <p>Δηλώνω υπεύθυνα ότι η αιτούσα επιχείρηση:</p>
        <div class="checkboxes-container">
          <div class="checkbox-item animate-field" *ngFor="let item of confirmationItems; let i = index" [style.--index]="i">
            <label class="custom-checkbox">
              <input 
                type="checkbox" 
                [(ngModel)]="item.checked"
              >
              <span class="checkmark-box"></span>
              <span class="checkbox-text">{{ item.text }}</span>
            </label>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <div class="button-section">
          <button 
            class="connectivity-button" 
            [disabled]="!allConfirmationsChecked()" 
            (click)="submitAll()"
          >
          {{'CHECK-ELIGIBILITY' | translate}}
          </button>
        </div>
      </div>
    </div>
  
    <!-- Success Message -->
   <!-- Success Message with Spinner -->
<div class="terms-popup animate-card" *ngIf="currentStep === 4">
    <div class="card-header">
      <h2>Επιτυχία!</h2>
    </div>
    <div class="card-body">
      <div class="success-message">
        <p>Γίνεται επεξεργασία της αίτησης σας.</p>
        <div class="spinner-container">
          <mat-spinner diameter="40" color="accent"></mat-spinner>
          <p class="waiting-text">Παρακαλώ περιμένετε...</p>
        </div>
      </div>
    </div>
  </div>
  </div>